module.exports = __webpack_public_path__ + "static/media/logo-camarabarracorda.62c497bd.png";